{
  "text": "<p>由于多次未能成功验证您的身份，我们已暂时锁定此邀请，以保护您的隐私。</p>\n<p>请不用担心 — 我们仍然可以提供帮助。</p>\n<p>请致电我们的团队完成预约：</p>\n<p><a><strong>☎️ {{phone}}</strong></a>（然后按 <strong>选项2</strong>）<br/>周一至周五，上午8点至下午5点。</p>",
  "title": "为保障您的安全，邀请已被锁定"
}
